<script lang="ts">
  import { setContext } from "svelte";
  import MainPage from "../../components/main-page.svelte";
  import { locale, t } from "../../i18n/index";

  export let language = "ko";

  const campaignSetting = { language };
  setContext("campaignSetting", campaignSetting);

  $: {
    locale.set(campaignSetting.language || "ko");
  }
</script>

<MainPage
  analyticsCampaignType="PROMOTION"
  successTitle={$t("promotion.successTitle")}
  successDescription={$t("promotion.successDescription")}
  failTitle={$t("promotion.failTitle")}
  failDescription={$t("promotion.failDescription")}
  maxWidth={{ value: 1200, unit: "px" }}
  wideMarginTop="0"
/>
